import classNames from 'classnames';

import { Markdown } from '@components/markdown/Markdown';

import { LocationRecord } from '@interfaces';

import styles from './navigation-location.module.scss';

interface NavigationLocationProps extends LocationRecord {
	className?: string;
}

export const NavigationLocation = ({
	title,
	address,
	mapLinkUrl,
	mapLinkLabel,
	className,
}: NavigationLocationProps) => {
	return (
		<div className={classNames(className, styles.location)}>
			<h2 className={styles.heading}>{title}</h2>
			<Markdown text={address} />
			<a
				className={classNames(
					styles.link,
					'anchor',
					'anchor--external-arrow-style-diagonal',
				)}
				href={mapLinkUrl}
			>
				{mapLinkLabel}
			</a>
		</div>
	);
};
